<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-document`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 4a2 2 0 012-2h25l9 9.429V44a2 2 0 01-2 2H8a2 2 0 01-2-2V4zm24 2v8.039h8V42H10V6h20zM14 28a1 1 0 011-1h10a1 1 0 011 1v2a1 1 0 01-1 1H15a1 1 0 01-1-1v-2zm1-9a1 1 0 00-1 1v2a1 1 0 001 1h18a1 1 0 001-1v-2a1 1 0 00-1-1H15z"/></svg>
</template>
<script>

export default {
  name: 'IconDocument',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
